import type React from 'react'
import type { IconProps } from './types'

const ListUl: React.FC<IconProps> = ({ size = 20, className = 'fill-neutral-900' }) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 16 16'
		className={className}
		fill='currentColor'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'>
		<path d='M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z' />
	</svg>
)

export default ListUl
